/*
 * Copyright: Infosim GmbH & Co. KG Copyright (c) 2000-2021
 * Company: Infosim GmbH & Co. KG,
 *                  Landsteinerstraße 4,
 *                  97074 Wuerzburg, Germany
 *                  www.infosim.net
 */
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { of } from 'rxjs';
import { catchError, first, map } from 'rxjs/operators';

const daysTillExpire = 7;

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  get lastError() {
    return this.errorMsg;
  }

  private token = '';
  private errorMsg = '';
  private authenticated = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private cookieService: CookieService
  ) {
    if (cookieService.check('currentToken')) {
      this.token = cookieService.get('currentToken');
    }
  }

  isAuthenticated() {
    return this.authenticated;
  }

  getToken() {
    return this.token;
  }

  setToken(token: string) {
    this.token = token;
    this.cookieService.set('currentToken', token, daysTillExpire, '/');
  }

  logout() {
    this.authenticated = false;
    this.cookieService.delete('currentToken', '/');
    this.token = '';

    this.router.navigate(['/login']);
  }

  tryLogin() {
    // returns 401 if the user doesn't have access
    return this.http
      .get(environment.DOC_SRC_FOLDER + '/' + environment.DOC_FOLDER + '/', {
        headers: new HttpHeaders({
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        }),
        responseType: 'text',
      })
      .pipe(
        map(() => {
          this.authenticated = true;
          return true;
        }),
        catchError((err) => {
          this.authenticated = false;

          if (err instanceof HttpErrorResponse) {
            if (err.status === 400) {
              this.errorMsg = 'Login failed, please try again.';
            } else if (err.status === 200) {
              this.errorMsg = 'Sorry something went wrong with the server please try again later.';
            } else if (err.status === 404) {
              this.errorMsg = 'Error 404 - Server resources not found.';
            } else {
              this.errorMsg = err.statusText;
            }
          } else {
            this.errorMsg = err;
          }
          return of(false);
        })
      );
  }

  login(user: string, pwd: string) {
    this.setToken(btoa(`${user}:${pwd}`));
    return this.tryLogin().pipe(
      map((res) => {
        if (res) {
          this.activeRoute.queryParams.pipe(first()).subscribe((params) => {
            const cont = params['continue'];
            const fragment = params['fragment'];
            const queryParams = { ...params };
            queryParams['fragment'] = undefined;
            queryParams['continue'] = undefined;

            this.router.navigate([cont ?? `/${environment.DOC_FOLDER}`], {
              ...(fragment ? { fragment } : {}),
              queryParams,
            });
          });
          return true;
        } else {
          return false;
        }
      })
    );
  }
}
